// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1556":"348da88d","2894":"0d0f1366"}[chunkId] + ".chunk.css";
};